import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

export const getAllVTOProduct = createAsyncThunk(
  "vto/getAllVTOProduct",
  async ({ categoryKey = "", brand_id = "" }, { rejectWithValue }) => {
    try {
      const queryParams = `?per_page=30&page=1&is_vto=true${
        categoryKey ? `&category=${categoryKey}` : ""
      }${brand_id ? `&brands=${brand_id}` : ""}`;

      const response = await GET(API.VTO + queryParams);
      if (response?.success) {
        return response?.data?.data || [];
      } else {
        return [];
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getBrands = createAsyncThunk(
  "vto/brand",
  async ({ categoryKey = "" }, { rejectWithValue }) => {
    try {
      const queryParams = `?&category_id=${categoryKey}`;

      const response = await GET(API.Brandings + queryParams);
      if (response?.success) {
        return response?.data || [];
      } else {
        return [];
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const vtoSlice = createSlice({
  name: "vto",
  initialState: {
    vtoProducts: [],
    status: "idle",
    error: null,
    brands:[]
  },
  reducers: {
    clearVTOProducts: (state) => {
      state.vtoProducts = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllVTOProduct.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllVTOProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.vtoProducts = action.payload;
      })
      .addCase(getAllVTOProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getBrands.fulfilled, (state, action) => {
        state.brands = action.payload;
      })
  },
});

export const { clearVTOProducts } = vtoSlice.actions;
export default vtoSlice.reducer;
